import { createReducer } from 'redux-starter-kit';
import {
  fetchViaSearch, fetchViaSearchDone, fetchUserSearchDone, fetchUserSearch,
} from './viaSearchUIActions';
import { selectRequest } from '../../domain/requests/RequestReducer';
import { selectInspectionSummary } from '../../domain/inspection/inspectionSummaryReducer';


export const selectSearchValue = state => state.via.ui.application.viaSearch.searchValue;

export const selectSearchResult = (state) => {
  const searchValue = selectSearchValue(state);
  if (!searchValue) return null;

  const searchQuery = state.via.ui.application.viaSearch.queries[searchValue];
  if (!searchQuery) return null;

  const request = selectRequest(state, searchQuery.requestId);
  if (!request) return null;

  const inspectionSearchResults = request.isLoading || !searchQuery.inspectionResults
    ? { isLoading: request.isLoading }
    : {
      isLoading: request.isLoading,
      allSearchResults: searchQuery.inspectionResults.allSearchResults,
      results: searchQuery.inspectionResults.summaries.map(inspectionCode => selectInspectionSummary(state, inspectionCode)),
    };

  return { inspectionSearchResults };
};

export const selectUserSearchValue = state => state.via.ui.application.viaSearch.userSearchValue;

export const selectUserSearchResult = (state) => {
  const searchValue = selectUserSearchValue(state);
  if (!searchValue) return null;

  const searchQuery = state.via.ui.application.viaSearch.userQueries[searchValue];
  if (!searchQuery) return null;

  const request = selectRequest(state, searchQuery.requestId);
  if (!request) return null;

  const userSearchResults = request.isLoading || !searchQuery.userResults
    ? { isLoading: request.isLoading }
    : {
      isLoading: request.isLoading,
      allSearchResults: searchQuery.userResults.allSearchResults,
      results: searchQuery.userResults.summaries,
    };

  return userSearchResults;
};

const initialViaSearchState = {
  searchValue: '',
  queries: {
    // [searchValue]: {
    //    requestTime: '2019-01-21T08:39:07Z',
    //    requestId: '123-456',
    //    inspectionResults: {
    //      allSearchResults: true,
    //      summaries: [1, 22],
    //    },
    // },
  },

  userSearchValue: '',
  userQueries: {
    // [searchValue]: {
    //    requestTime: '2019-01-21T08:39:07Z',
    //    requestId: '123-456',
    //    userResults: {
    //      allSearchResults: true,
    //      summaries: [{ userId: 1, username: 'stsf', companyName: '...', ...}, ...],
    //    },
    // },
  },
};

/**
 * A reducer for handling the global search state.
 */
export default createReducer(initialViaSearchState, {
  // The search value is being looked up on the server.
  [fetchViaSearch]: (state, { payload }) => ({
    ...state,
    searchValue: payload.searchValue,
    queries: {
      ...state.queries,
      [payload.searchValue]: {
        requestId: payload.requestId, // e.g. "BYX": "the-id-of-the-latest-request"
        requestTime: null,
      },
    },
  }),

  // The search value has come back from the server with results.
  [fetchViaSearchDone]: (state, action) => {
    const { searchValue, requestTime, inspectionResults } = action.payload;

    return {
      ...state,
      queries: {
        ...state.queries,
        [searchValue]: {
          ...state.queries[searchValue],
          requestTime,
          inspectionResults,
        },
      },
    };
  },

  // The search value is being looked up on the server.
  [fetchUserSearch]: (state, { payload }) => ({
    ...state,
    userSearchValue: payload.searchValue,
    userQueries: {
      ...state.userQueries,
      [payload.searchValue]: {
        requestId: payload.requestId,
        requestTime: null,
      },
    },
  }),

  // The search value has come back from the server with results.
  [fetchUserSearchDone]: (state, action) => {
    const { searchValue, requestTime, searchResults } = action.payload;

    return {
      ...state,
      userQueries: {
        ...state.userQueries,
        [searchValue]: {
          ...state.userQueries[searchValue],
          requestTime,
          userResults: searchResults,
        },
      },
    };
  },
});
